import { NgModule, APP_INITIALIZER, Injector } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GridStackDirective } from './directive/gridstack.directive';
import { GridStackItemDirective } from './directive/gridstack-item.directive';
import { DraggableDirective } from './directive/draggable.directive';
import { DroppableDirective } from './directive/droppable.directive';
  

@NgModule({
    declarations: [
        GridStackDirective,
        GridStackItemDirective,
        DraggableDirective,
        DroppableDirective
    ],
    exports: [
        GridStackDirective,
        GridStackItemDirective,
        DraggableDirective,
        DroppableDirective
    ],
    imports: [
        CommonModule,
        RouterModule
    ],
    providers: [
        
    ]
})
export class GridStackModule {
    constructor() {

    }
}



